import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

import { refundTableColumnsConfig } from "./refundTableColumnsConfig";
import { Table } from "../../../component/table/Table";

import { useNavigate } from "react-router-dom";
import {
  selectRefunds,
  useGetRefundListQuery,
} from "../../../services/refund/refundApiSlice";
import { selectRefundState } from "../../../store/refund/refundFilterSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const RefundTablePage = () => {
  const navigate = useNavigate();
  const appliedFilters = useSelector(selectRefundState);
  const { isLoading, isFetching } = useGetRefundListQuery(appliedFilters);

  const tableData = useSelector(selectRefunds);

  const handleOpenModal = useCallback((rowData, action) => {
    // Implement your modal logic here
    console.log("Row Data: ", rowData, "Action: ", action);
  }, []);

  const handleRefundDetails = useCallback(
    (refundId) => {
      // dispatch(setOrderId({ order_id: rowId }));
      console.log("details", refundId);
      navigate(`/refund_orders/${refundId}`);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () => refundTableColumnsConfig(handleOpenModal, handleRefundDetails),
    [handleOpenModal, handleRefundDetails],
  );
  if (isLoading && tableData.length === 0) {
    return <CategoryPageSkeleton />;
  }

  return (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading}
      isFetching={isFetching}
    />
  );
};
